import {useEffect} from "react";
import './App.css';
import Login from './component/login/Login';
import {BrowserRouter, Route, Routes, useNavigate} from "react-router-dom";
import EmailVerification from "./component/email-verification/EmailVerification";
import NewPassword from "./component/new-password/NewPassword";
import Dashboard from "./component/dashboard/Dashboard";
import CreateBlog from "./component/create-blog/CreateBlog";
import Blog from './component/blog/blog';
import PrivateRoutes from "./PrivateRoutes";
import CreateNewHackathon from './component/create-new-hackathon/CreateNewHackathon';
import Hackathon from "./component/hackathon/Hackathon";
import Products from "./component/products/Products";
import CreateProduct from "./component/create-proudct/CreateProduct";
import Partnership from "./component/partnership/Partnership";
import Sponsorship from "./component/sponsorship/Sponsorship";
import ApplyForJudges from "./component/apply-for-judges/ApplyForJudges";
import Registration from "./component/RegistrationList/Registration";
import TeamCaption from "./component/team-caption/Team-caption";


function App() {

    return (
        <>
            {/*<BrowserRouter>*/}
            {/*    <Routes>*/}
            {/*        <Route path="/" element={<Login/>}/>*/}
            {/*        <Route path="/email-verification" element={<EmailVerification/>}/>*/}
            {/*        <Route path="/new-password" element={<NewPassword/>}/>*/}
            {/*        <Route path="/dashboard" element={<Dashboard/>}/>*/}
            {/*        <Route path="/create-blog" element={<CreateBlog/>}/>*/}
            {/*        <Route path='/blog' element={<Blog/>}/>*/}
            {/*    </Routes>*/}
            {/*</BrowserRouter>*/}
            <BrowserRouter>
                <Routes>
                    {/*<Route element={<PrivateRoutes/>}>*/}

                    {/*</Route>*/}
                    <Route path="/" element={<Login/>}/>
                    <Route path="/dashboard" element={<Dashboard/>}/>
                    <Route path="/email-verification" element={<EmailVerification/>}/>
                    <Route path="/new-password" element={<NewPassword/>}/>
                    <Route path="/create-new-hackathon" element={<CreateNewHackathon/>}/>
                    <Route path="/hackathon" element={<Hackathon/>}/>
                    <Route path="/products" element={<Products/>}/>
                    <Route path="/create-product" element={<CreateProduct/>}/>
                    <Route path="/update-product/:id" element={<CreateProduct/>}/>
                    <Route path="/create-blog" element={<CreateBlog/>}/>
                    <Route path="/create-blog/:id" element={<CreateBlog/>}/>
                    <Route path='/blog' element={<Blog/>}/>
                    <Route path='/partnership' element={<Partnership/>}/>
                    <Route path='/sponsorship' element={<Sponsorship/>}/>
                    <Route path='/apply-as-judges' element={<ApplyForJudges/>}/>
                    <Route path='/registration' element={<Registration/>}/>
                    <Route path='/team-caption' element={<TeamCaption/>}/>

                </Routes>
            </BrowserRouter>
        </>
    );
}

export default App;
